/**
 * @file コンポーネント：フル動画ページボタンリスト スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { zIndex } from "~/src/styles/constants";

// スタイル
export const StyledButtonlist = styled.ul`
    display: flex;
    flex-direction: row-reverse;
    position: fixed;
    right: 16px;
    bottom: 16px;
    z-index: ${zIndex.fullvideoButtonlist};
`;

export const StyledButtonlistItem = styled.li`
    margin-right: 16px;

    &:first-of-type {
        margin-right: 0;
    }
`;
